@import '~style-sheet-helpers/core.less';
@import '../../../../../../../app-brand/entities/entity-layer.module.less';
@import '../../../../../../../constants/spacing.module.less';
@import '../../../../../../../constants/screen-width-breakpoints.module.less';

.ship-from-form {
  max-width: 835px;
  margin: @space-0 auto @space-64;
  max-height: 80vh;
  text-align: left;

  @media @mobile, @ultramobile {
    max-height: none;
    margin-bottom: @space-24;
  }
}

.form-header {
  text-align: left;
}

.form-title {
  font-weight: 700;
  margin: @space-0 @space-0 @space-8;
}

.separator {
  height: 1px;
  background-color: var(--gray-DFE4E8);
  margin: @space-16 @space-0 @space-0;
}

.address-form-headers {
  margin-bottom: @space-8;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: @space-8;
}

.form-columns {
  margin-top: @space-24;
  display: flex;
  gap: @space-40;
  justify-content: center;
  max-width: 780px;
  padding: @space-16 @space-16 @space-24;
  background-color: var(--white);
  border-radius: 8px;
  border: 1px solid var(--gray-E4E5E7);

  @media @mobile, @ultramobile {
    flex-direction: column;
    gap: @space-16;
  }
}

.left-column,
.right-column {
  width: 100%;
}

.settings-checkboxes {
  gap: @space-24;
}

.loading-indicator {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
}

.custom-residential-checkbox {
  font-size: 14px;
}

.custom-origin-address {
  margin-top: @space-8;
}
